import { render, staticRenderFns } from "./classRecord.vue?vue&type=template&id=078b81d6&scoped=true&"
import script from "./classRecord.vue?vue&type=script&lang=js&"
export * from "./classRecord.vue?vue&type=script&lang=js&"
import style0 from "./classRecord.vue?vue&type=style&index=0&id=078b81d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078b81d6",
  null
  
)

export default component.exports